import React from "react";

import {
	SortableContext,
	verticalListSortingStrategy,
} from "@dnd-kit/sortable";

import { StyledList } from "./SongList.style";
import SongListTimeSeparator from "./SongListTimeSeparator";
import { useWaitingListData } from "services/hooks/useWaitingListData";
import DraggablesSongsList from "./DraggableSongList";
import { LastSong } from "../LastSong/LastSong";


const SongList: React.FC = () => {
	const { splitWaitingList, sessionEndTimeStamp } = useWaitingListData();
	const songListRef = React.useRef<HTMLUListElement | null>(null);

	const allSongs = [
		...splitWaitingList.playableWaitingList.map((s) => ({
			...s,
			section: "playable",
		})),
		...splitWaitingList.elapsedTimeWaitingList.map((s) => ({
			...s,
			section: "elapsed",
		})),
	];

	return (
		<SortableContext
			items={allSongs.map((item) => item.globalIndex.toString())}
			strategy={verticalListSortingStrategy}
		>
			<StyledList ref={songListRef}>
				<DraggablesSongsList
					list={
						!sessionEndTimeStamp
							? allSongs
							: splitWaitingList.playableWaitingList
					}
					elapsedTime={false}
				/>
				{sessionEndTimeStamp && (
					<>
						<LastSong />
						<SongListTimeSeparator />
						<DraggablesSongsList
							list={splitWaitingList.elapsedTimeWaitingList}
							elapsedTime={true}
						/>
					</>
				)}
			</StyledList>
		</SortableContext>
	);
};

export default SongList;
